import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      boxSizing: 'border-box',
    },
    '&__menu_container': {
      gap: theme.value.spacing,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    '&__container': {
      width: '358px',
    },
    '&--full-width': {
      width: '100%',
    },
    position: 'relative',
    width: 'fit-content',
    '&__menu': {
      position: 'absolute',
      display: 'none',
      padding: '0.625rem',
      width: '100%',
      background: '#fff',
      boxShadow: '0px 6px 30px 0px rgba(0, 0, 0, 0.10)',
      borderBottomLeftRadius: '0.5rem',
      borderBottomRightRadius: '0.5rem',
      marginTop: '40px',
      zIndex: 20,
    },
    '&--active &__menu': {
      display: 'block',
    },
    '&__divider': {
      width: '100%',
      height: '1px',
      background: theme.value.colors.gray.light3,
      marginBlock: '0.5rem',
    },
    '&__label': {
      display: 'block',
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.semibold,
      lineHeight: '1.25rem',
    },
    '&__helper-text': {
      fontSize: '0.75rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.regular,
      lineHeight: '1.125rem',
      color: theme.value.colors.gray.medium1,
      marginTop: '0.125rem',
    },
    '&__select': {
      display: 'flex',
      width: '100%',
      background: '#fff',
      border: `1px solid ${theme.value.colors.gray.light2}`,
      borderRadius: theme.value.input.borderRadius,
      padding: '0.25rem 0.5rem',
      gap: '0.5rem',
      height: '32px',
      fontSize: '0.813rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.regular,
      lineHeight: '20px',
      MozAppearance: 'none',
      WebkitAppearance: 'none',
      appearance: 'none',
      backgroundImage:
          "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black'><path fill-rule='evenodd' d='M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z' clip-rule='evenodd' stroke='black' stroke-width='1'/></svg>\")",
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 0.7rem top 50%',
      backgroundSize: '0.65rem auto',
      '&:hover': {
        borderColor: theme.value.colors.gray.medium2,
      },
      '&:focus': {
        borderColor: theme.value.colors.primary.light1,
      },
      '&:focus-visible': {
        outline: 'none',
      },
      '&:disabled': {
        backgroundColor: theme.value.colors.gray.light3,
        borderColor: theme.value.colors.gray.light3,
        cursor: 'not-allowed',
      },
    },
    '&--error &__select:not(:disabled), &--error &__select:focus': {
      borderColor: theme.value.colors.error,
    },
    '&--error + &__helper-text': {
      color: theme.value.colors.error,
    },
  }));

  return baseClass;
};
